import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants } from '../../constants/Constants';

//components
import { MessageHandlerComponent } from '../../components/Controls/MessageHandler.component';
import {BlockComponent} from '../Controls/Block.component';
import {RequestTypeMultiSelectComponent} from '../../components/DomainData/RequestTypeMultiSelect.component';
import {SalesOfficeMultiSelectComponent} from '../../components/DomainData/SalesOfficeMultiSelect.component';
import { Observable } from 'rxjs';



@Component({
    selector: 'my-maintain-salesoffice-requesttype',
    templateUrl: './MaintainSalesOfficeRequestTypes.component.html'
})
export class MaintainSalesOfficeRequestTypes implements OnInit {

    appSetting: ent.AppSetting;
    userInfo: ent.UserInfo;
    records: ent.SalesOfficeRequestType[] = [];

    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;

    @ViewChild(RequestTypeMultiSelectComponent) requestTypeMultiSelectComponent: RequestTypeMultiSelectComponent;
    @ViewChild(SalesOfficeMultiSelectComponent) salesOfficeMultiSelectComponent: SalesOfficeMultiSelectComponent;

    constructor(private authenticationService: serv.AuthenticationService, private adminService: serv.AdminService, private domainDataService: serv.DomainDataService) {

    }

    ngOnInit(): void {
        this.userInfo = this.authenticationService.getUserInfo();

        this.doSearch();
        
    }

    ngAfterViewInit() {
        this.loadSearchCriteria();
    }

    public onSearchClick(event: any){
        this.doSearch();
    }
    public onCheckAll(event: any){
        for (var rec of this.records) {
            rec.IsEnabled = true;
        }
    }
    public onUncheckAll(event: any){
        for (var rec of this.records) {
            rec.IsEnabled = false;
        }
    }

    public onSaveClick(event: any){
        let request: ent.SaveSalesOfficeRequestTypesRequest = { 
            SavedByEmployee: this.userInfo.Employee,
            SalesOfficeRequestTypes: this.records
        };

        this.adminService.saveSalesOfficeRequestTypes(request).subscribe(x=>{
            this.messageHandlerComponent.handleResponse(x);
        });

    }

    public doSearch() {
        this.blockComponent.blocked = true;

        let request: ent.GetDataRequest = {Employee: this.userInfo.Employee};
        
        let filter: filters.SalesOfficeRequestTypeFilter = { 
            GetDataRequest: request,
            
        };

        if (this.requestTypeMultiSelectComponent !=null ) {
            filter.RequestTypeIDs = this.requestTypeMultiSelectComponent.selectedIDs;
        }

        if (this.salesOfficeMultiSelectComponent !=null ) {
            filter.SalesOfficeIDs = this.salesOfficeMultiSelectComponent.selectedIDs;
        }
                
        this.adminService.getSalesOfficeRequestTypes(filter).subscribe(x => {
            this.records = x;
            this.blockComponent.blocked = false;
        }, err => {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.blockComponent.blocked = false;
        });

    }

    loadSearchCriteria() {
        
        Observable.forkJoin([
            this.loadRequestTypes(),
            this.loadSalesOffices()
          ]).subscribe(value => {
                
          });
        
    }

    loadRequestTypes(): Observable<any> {
        
        return new Observable((observer) => { 
            this.requestTypeMultiSelectComponent.load().subscribe(x=> {
                observer.next(x);
                observer.complete();
            })
        });
    }
    
   

    loadSalesOffices(): Observable<any> {
        
        return new Observable((observer) => { 
            this.salesOfficeMultiSelectComponent.load().subscribe(x=> {
                observer.next(x);
                observer.complete();
            });

        });
    }
    
    handleResponse(response: ent.Response) {

        this.messageHandlerComponent.handleResponse(response);

    }

}